import React from "react";
import "./Footer.css";
import { Link, useLocation } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { faEnvelope, faGlobe, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Common_download_btn from "../common/common-download-btn/Common_download_btn";

const Footer = () => {
  const location = useLocation();

  return (
    <>
      <Link to={"/"}>
        <div className="Footer_logo_holder">
          <img
            className="logo_img"
            src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
            alt="ayansh logo"
          />
        </div>
      </Link>

      <section className="Footer">
        <div className="container">




          <div className="heading_holder">
            <h1>CAMPUS DEAL is a smart platform that connects customers with verified vendors  <br />and service experts for home, office, and commercial needs — all in one place.</h1>
          </div>



          <div className="footer_links_holder">
            <div className="row">
              {/* Quick Links */}
              <div className="col-lg-2 col-md-4 col-sm-6">
                <div className="title_link"><h6>Quick Links</h6></div>
                <Link to={"/"}>
                  <p>Home</p>
                </Link>

                <Link to={"/about-us"}>
                  <p>About Us</p>
                </Link>

                <Link to={"/services"}>
                  <p>Services</p>
                </Link>

                <Link to={"/contact-us"}>
                  <p>Contact Us</p>
                </Link>
              </div>

              {/* Follow us */}
              <div className="col-lg-2 col-md-4 col-sm-6">
                <div className="title_link"><h6>Follow us</h6></div>
                <Link to={"https://www.facebook.com/"} target='_blank'>
                  <p>Facebook</p>
                </Link>
                <Link to={"https://x.com/"} target='_blank'>
                  <p>Twitter</p>
                </Link>
                <Link to={"https://www.instagram.com/"} target='_blank'>
                  <p>Instagram</p>
                </Link>
                <Link to={"https://www.linkedin.com/"} target='_blank'>
                  <p>LinkedIn</p>
                </Link>
              </div>

              {/* Support Links */}
              <div className="col-lg-2 col-md-4 col-sm-6">
                <div className="title_link">
                  <h6>Support:</h6>
                </div>
                <Link to="/terms-and-condition">
                  <p>Terms and Conditions</p>
                </Link>
                <Link to="/privacy-policy">
                  <p>Privacy Policy</p>
                </Link>
              </div>

              {/* Contact Info */}
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="title_link">
                  <h6>Contact us:</h6>
                </div>

                <Link to="mailto:support@campusdeal.in" target="_blank" className="footer_link">
                  <p>
                    <FontAwesomeIcon className="footer_contact_icon" icon={faEnvelope} /> Email: support@campusdeal.in
                  </p>
                </Link>

                <Link to="https://www.campusdeal.in/" target="_blank" className="footer_link">
                  <p>
                    <FontAwesomeIcon className="footer_contact_icon" icon={faGlobe} /> website: www.campusdeal.in
                  </p>
                </Link>

                <Link to="tel:+91-9876543210" target="_blank" className="footer_link">
                  <p>
                    <FontAwesomeIcon className="footer_contact_icon" icon={faPhone} /> Phone: +91-9876543210
                  </p>
                </Link>
              </div>

              {/* Download Our App  */}
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="title_link">
                  <h6>Download Our App</h6>
                </div>

                <Common_download_btn />

              </div>

            </div>
          </div>

          <div className="footer_copyright_holder">
            <p>
              Copyright ©2025 All Rights Reserved. Developed by{" "}
              <Link to="https://www.profcymaglobal.com/" target="_blank">
                <span>Profcyma</span>
              </Link>.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
